import { Grid } from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { useTranslate } from "src/locales";
import { useAppSelector } from "src/app/hooks";
import { referenceService } from "src/api/references/referenceService";
import { HospitalBuildingResponseDto } from "src/api/references/referenceServicesDtos";
import ByzAsynchronousSelectV2 from "src/components/core-components/ByzAsynchronousSelectV2";

interface Props {
  onChange: (val: HospitalBuildingResponseDto | null) => void;
  value?: HospitalBuildingResponseDto | null;
  wrapInGrid?: boolean;
  sx?: any;
}

export default function BuildingFilter({ onChange, value, wrapInGrid = true, sx }: Props) {
  const { t } = useTranslate();
  const [selectedBuilding, setSelectedBuilding] = useState<HospitalBuildingResponseDto | null>(value ?? null);
  
  const { user } = useAppSelector((state) => state.auth);
  const selectedOfficeId = useAppSelector((state) => state.auth.selectedOfficeId);
  const selectedOffice = user?.UserAssPriviliges?.find(office => office.ID === selectedOfficeId);
  const officeId = Number(selectedOffice?.OFF_ID || user?.UserAssPriviliges?.[0]?.OFF_ID);

  useEffect(() => {
    setSelectedBuilding(value ?? null);
  }, [value]);

  useEffect(() => {
    if (selectedOfficeId && user) {
      setSelectedBuilding(null);
      onChange(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOfficeId, user]);

  const fetchBuildings = useCallback(async (): Promise<HospitalBuildingResponseDto[]> => {
    return await referenceService.hospitalBuilding.getAllHospitalBuildings({ offId: officeId });
  }, [officeId]);

  const selectComponent = (
    <ByzAsynchronousSelectV2<HospitalBuildingResponseDto>
      fetchOptions={fetchBuildings}
      label={t("building-select")}
      onChange={(val) => {
        const selected = val as HospitalBuildingResponseDto | null;
        setSelectedBuilding(selected);
        onChange(selected);
      }}
      value={selectedBuilding}
      selectLabel="name"
      sx={{ width: "100%", ...sx }}
    />
  );

  if (wrapInGrid) {
    return (
      <Grid item xs={12} sm={6} md={2}>
        {selectComponent}
      </Grid>
    );
  }

  return selectComponent;
}

